import { ZOOM_STORAGE_KEY } from '@Containers/Zoom/ZoomConstants';
import { zoomBranch } from '@Containers/Zoom/ZoomSelectors';

// CAS Number
import { saveStateToStorage as saveStateToStorageCasNumber } from '@Containers/CasNumber/persistedState';
import AppStorage from '@Services/AppStorage';

export default function saveStoreBeforeUnload(store) {
  window.addEventListener('beforeunload', function () {
    const state = store.getState();

    AppStorage.instance.set(ZOOM_STORAGE_KEY, zoomBranch(state)?.toJS());
    saveStateToStorageCasNumber(state);
  });
}
